export const config = {
    "name": "选题统计",
    "key": "selectionStatistics",
    "nav": [
        {
            "name": "单位",
            "tabKey": "0",
            "request": {
                "url": "/cm-sites-storage-statistics/busStatistics/topicSelectionStatistics",
                "method": "post",
                "params": {
                    // 检索字段
                    name: "",
                    // 排序字段
                    // order: "",
                    // 排序方式
                    // direction: -1,
                    startTime: 0,
                    endTime: 0,
                    pageSize: 10,
                    pageNum: 1,
                },
                paramsConfig: {
                    size: "pageSize",
                    page: "pageNum",
                    sort: {
                        field: "order",
                        order: {
                            key: "sort",
                            select: {"ascend": '1', "descend": '-1'}
                        },
                    },
                },
                resConfig: {
                    count: "count",
                    data: "data"
                },
                "defaultParams": {
                    // 检索字段
                    name: "",
                    // 排序字段
                    // order: "",
                    // 排序方式
                    // direction: -1,
                    startTime: 0,
                    endTime: 0,
                    pageSize: 10,
                    pageNum: 1,
                },
                "contentType": "json",
            },
            "renderSearch": {
                "searchConfig": [
                    [
                        {
                            "style": {
                                "float": "left"
                            },
                            "component": {
                                "name": "sta_Input",
                                "config": {
                                    style: {
                                        width: 224
                                    }
                                }
                            },
                            "placeholder": "请输入姓名",
                            "disabled": false,
                            "id": "sta_name",
                            "size": "default",
                            "labelCode": "name",
                            "labelName": "请输入姓名",
                            "defaultValue": "",
                            "regStr": "",
                            "regMsg": ""
                        },
                        {
                            "style": {
                                "float": "left"
                            },
                            "component": {
                                "name": "sta_Button",
                                "config": {
                                    btnName: "查询",
                                    type: "primary",
                                    clickCall: "onSearch",
                                    style: {
                                        width: 64
                                    }
                                }
                            },
                            "disabled": false,
                            "id": "sta_searchBtn",
                            "size": "default",
                            "labelCode": "",
                        },
                        {
                            "style": {
                                "float": "left"
                            },
                            "component": {
                                "name": "sta_Button",
                                "config": {
                                    btnName: "重置",
                                    type: "default",
                                    clickCall: "onReset",
                                    noRestKey: ["startTime", "endTime"],
                                    style: {
                                        width: 64
                                    }
                                }
                            },
                            "disabled": false,
                            "id": "sta_searchBtn",
                            "size": "default",
                            "labelCode": "",
                        },
                    ],
                    [
                        {
                            "style": {
                                "float": "left"
                            },
                            "component": {
                                "name": "sta_Button",
                                "config": {
                                    btnName: "导出",
                                    type: "default",
                                    clickCall: "onExport",
                                    "request": {
                                        "url": "/cm-sites-storage-statistics/busStatistics/exportBusStatistics",
                                        "method": "downloadPost",
                                        "params": {
                                            busName: "busTopicSelection",
                                            pageSize: 9999
                                        },
                                        "contentType": "json",
                                    },
                                    style: {
                                        width: 64
                                    }
                                }
                            },
                            "disabled": false,
                            "id": "sta_searchBtn",
                            "size": "default",
                            "labelCode": "",
                        },
                        {
                            "style": {
                                "float": "right",
                                marginLeft: 'auto'
                            },
                            "component": {
                                "name": "sta_Date",
                                "config": {
                                    selectDateConfig: {
                                        defaultKey: "thisMonth",
                                        selectConfig: ["today", "yesterday", "thisWeek", "lastWeek", "thisMonth", "lastMonth"]
                                    },
                                    onChangeCallFun: "onSearch",
                                    style: {
                                        width: 768
                                    }
                                }
                            },
                            "value:": "this.state.params.name",
                            "placeholder": "自定义日期范围",
                            "disabled": false,
                            "id": "sta_name",
                            "size": "default",
                            "labelCode": ["startTime", "endTime"],
                            "defaultValue": [null, null],
                            "labelName": "",
                            "regStr": "",
                            "regMsg": ""
                        },
                    ]
                ]
            },
            "renderTable": {
                "defaultItemWidth": 200,
                "columns": [
                    {
                        "title": '序号',
                        "width": 100,
                        "dataIndex": 'index',
                        "key": 'index',
                        // "fixed": 'left',
                    },
                    {
                        title: '姓名',
                        dataIndex: 'publisher.userName',
                        ellipsis: true,
                    },
                    {
                        title: '已提交',
                        dataIndex: 'yitijiao',
                        ellipsis: true,
                        sorter: true,
                    },
                    {
                        title: '已采用',
                        dataIndex: 'yicaiyong',
                        ellipsis: true,
                        sorter: true,
                    },
                    {
                        "title": '采用率',
                        "dataIndex": 'caiyonglv',
                        ellipsis: true,
                        sorter: true,
                    },
                    {
                        title: '已弃用',
                        dataIndex: 'yiqiyong',
                        ellipsis: true,
                        sorter: true,

                    },
                    {
                        "title": '弃用率',
                        "dataIndex": 'qiyonglv',
                        ellipsis: true,
                        sorter: true,
                    },
                ]
            },
            "renderPage": {
                size: "middle",
                pageSizeOptions: ['10', '20', '30', '40']
            }
        },
    ]
};

export const columns = [
    {
        "title": '序号',
        "width": 100,
        "dataIndex": 'index',
        "key": 'index',
        // "fixed": 'left',
    },
    // {
    //     title: 'Name',
    //     dataIndex: 'name',
    //     sorter: true,
    //     "key": 'name',
    //     // "fixed": 'left',
    //     ellipsis: true,
    // },
    {
        title: 'Age',
        // width: 100,
        dataIndex: 'age',
        key: 'age',
        // fixed: 'left',
    },
    {
        title: 'Column 1',
        dataIndex: 'address',
        key: '1',
        // width: 150,
        ellipsis: true,
    },
    {"title": 'Column 8', "dataIndex": 'address', "key": '8'},
    {
        "title": 'Action',
        "key": 'operation',
        "dataIndex": 'address',
        // "fixed": 'right',
        // "width": 100,
        ellipsis: true,
    },
]